module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Konta papildināšana")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui info icon message"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Lūdzu uzgaidiet!\n        ")]), _vm._v(" "), _c('p', [_vm._v("Notiek maksājuma apstrāde...")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1c9bdbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopUpAccountProcessPage.vue
// module id = 365
// module chunks = 1